import React from 'react'

function NotificationsAddendumLanguageOfAgreement() {
  return (
    <div className="addendum-language-of-agreement">
      <h2>ADDENDUM TO AUTOMATIC ROLLOVER SERVICES AGREEMENT </h2>
      <h3>(Notification Services)</h3>
      <p>
        The undersigned, in its capacity as (i) Plan Fiduciary or (ii)
        recordkeeper or third party administrator (“Plan Service Provider”) as
        authorized agent of a Plan Fiduciary and, in the case of both (i) and
        (ii) on behalf of a Plan, has selected Custodian and we have agreed to
        provide services to the Plan related to furnishing a written notice to
        Plan participants regarding involuntary distributions of participants’
        balances in an active and/or terminating Plan (“Notification Services”),
        pursuant to the terms and conditions of this Addendum, as an additional
        service adjunct to the automatic rollover IRA services provided under
        the Automatic Rollover Services Agreement effective between Plan
        Fiduciary and Custodian (“Agreement”). Each of Plan Fiduciary and Plan
        Service Provider may be referred to as “Plan Agent”. By executing this
        Addendum, Plan Agent agrees to the terms and conditions herein on its
        behalf and on behalf of each Plan for which it requests Notification
        Services. Each of Custodian and Plan Agent may be referred to as a party
        or collectively, the parties.
      </p>
      <p>
        All references in this Addendum to “you” or “your” refer to the Plan
        Agent signing this Addendum for itself and on behalf of a Plan. The term
        Plan refers to each Plan for which Plan Agent acts as Plan Fiduciary or
        Plan Service Provider and for which Notification Services are performed.
        Capitalized terms have the meaning given in the Agreement unless
        otherwise defined in this Addendum. If there is a conflict between the
        Agreement and this Addendum, the terms of this Addendum will control
        with respect to Notification Services.
      </p>
      <p>
        1. Participant Notification Services. The Plan provides for certain
        involuntary distributions of participants’ balances in an active and/or
        terminating Plan and has certain obligations to furnish prior written
        notice to Plan participants of the involuntary distribution and of their
        ability to make an election as to the distribution of the funds
        (“Notice”). You or your authorized agent will provide to us the (i)
        Notice and corresponding election form, and any other disclosures,
        documents and materials, as applicable, which comply with the terms of
        the Plan and all applicable Laws (collectively, “Notification
        Materials”), and (ii) Notification Information (as defined below) to be
        used for Notification Services. We will populate the Notice with the
        Notification Information and assemble the Notification Materials,
        address and mail the Notification Materials to each participant via
        first class United States Mail, and provide reporting to you which may
        include Participant Election grace period tracking, mailing status and
        Notification Materials returned as undeliverable, and other data agreed
        to by the parties from time to time (“Notification Results”). We use
        third party Notification Materials compilers and mailing services
        vendors (“Services Vendor”) to provide Notification Services, and we
        reserve the right to change, from time to time, the Services Vendor(s)
        we use to provide such Services. The availability of services provided
        to us by any Services Vendor may change from time to time and we reserve
        the right at any time to modify or discontinue temporarily or
        permanently, the Notification Services or any part thereof with or
        without notice.
      </p>
      <p>
        <b>2. Your Responsibilities. </b> Plan Agent will direct us to mail, on
        behalf of the Plan, Notification Materials to Plan participants pursuant
        to Notification Information provided by or on behalf of the Plan by Plan
        Agent. You will make such direction through an individual authorized to
        act for the Plan Agent. The direction will include:
      </p>
      <p>
        (a) information requested by us to perform Notification Services for
        each participant, which may include, without limitation, (i)
        participant’s full name, (ii) current or best known address of the
        participant, (iii) participant’s vested plan account balance, if
        applicable, (iv) Participant Election grace period and (v) any
        information reasonably requested by us to assist us in performing
        Notification Services requested (“Notification Information”); and
      </p>
      <p>
        (b) the Notification Materials, which you will provide to us (i) through
        our online portal or upload via electronic data file, or (ii) direct us
        to access from your authorized agent or our Services Vendor, if
        available and applicable. You represent and warrant for yourself and on
        behalf of each Plan that the Notification Materials satisfy the terms of
        the Plan and all applicable Laws, including without limitation, the Safe
        Harbor requirements for notifications to participants for distributions
        from an active and /or terminating Plan as described in Title 29 of the
        Code of Federal Regulations Sections 2550.404a-2 and 404a-3 and Sections
        401(a)(31)(B) and 402(f) of the Code, as applicable, and any successor
        provisions or additional regulatory guidance or Laws that may govern
        Plan’s responsibilities with respect to furnishing a written Notice to
        Plan participants. Plan Agent is solely responsible to determine that
        Notification Materials comply with the terms of the Plan and all
        applicable Laws, and discharge Plan’s notification requirements under
        applicable Laws. We will not review and are not responsible for the
        contents of the Notification Materials provided by you or your
        authorized agent, or their compliance with the terms of the Plan, Safe
        Harbor notification requirements, or applicable Laws. The Notification
        Materials will instruct participants to contact Plan Agent or its
        authorized agent directly to make a Participant Election. We shall have
        no responsibility for any communication from a participant to us.
      </p>
      <p>
        (c) You or your authorized agent will upload the Notification
        Information and Notification Materials, if applicable, to us by
        electronic data file in a format acceptable to us. You represent you
        have the right or authorization from the Plan to disclose the
        Notification Information to us in connection with the Services. Each
        transfer of an electronic file will serve as evidence of your direction
        to us on behalf of a Plan to provide Notification Services and as your
        representation for yourself and on behalf of the Plan, that the
        Notification Materials comply with the requirements set forth in Section
        2(b) of this Addendum. You specifically acknowledge, on your behalf and
        on behalf of the Plan, that we use third-party Services Vendors to
        provide Notification Services, that we may change such vendors at any
        time, and by using the Notification Services, you agree and consent on
        your behalf and on behalf of the Plan to the sharing of Notification
        Materials and Notification Information with such vendors to the extent
        necessary to enable vendor activities related to the provision of
        Notification Services. By providing Notification Information to us, you
        represent and warrant that you have obtained all required consents,
        approvals, permits and authorizations required for engagement of Inspira
        Financial to perform Notification Services on behalf of a Plan, to enter
        into this Addendum on your behalf and on behalf of the Plan, and to
        share a Plan’s Notification Information with us and Services Vendor from
        time to time.
      </p>
      <p>
        (d) In the event Notification Materials are returned and reported as
        undeliverable, you represent and warrant for yourself and on behalf of
        the Plan that Plan will take steps to locate the participant consistent
        with the Safe Harbor requirements for notifications to participants as
        described in Title 29 of the Code of Federal Regulations Sections
        2550.404a-3(e)(2) prior to requesting additional Notification Services
        for the participant.
      </p>
      <p>
        <b>3. Our Responsibilities. </b> Upon receipt of Notification
        Information from you, which serves as evidence of your direction to us
        to perform Notification Services on behalf of a Plan, we will:
      </p>
      <p>
        (a) Populate the Notification Materials with the Notification
        Information, address and mail the Notification Materials via first class
        United States Mail to each identified participant based upon the
        Notification Information provided. We have no obligation to verify the
        accuracy of the Notification Information, Notification Materials or
        participant delivery addresses provided by you and have no obligation to
        attempt to update or search for a participant address.
      </p>
      <p>
        (b) Report the Notification Results to you. The time frame in which you
        receive Notification Results depends on numerous factors and no specific
        Notification Results delivery time is guaranteed.
      </p>
      <p>
        (c) We will not store or maintain your electronic data file(s),
        associated Notification Materials or Notification Information on your
        behalf or for a Plan once Notification Services are performed and
        Notification Results are available, and any data file(s), Notification
        Materials or Notification Information submitted to us may be deleted 180
        days after Notification Results are available. Data cannot be recovered
        once deleted. You acknowledge for yourself and on behalf of any Plan,
        that you are solely responsible for the maintenance of Notification
        Information, Participant Elections, and other relevant notification
        records, on behalf of the Plan and we shall not be liable for any loss
        or destruction of your electronic data file(s), associated Notification
        Materials or Notification Information as provided herein. Each party is
        solely responsible for its own compliance obligations.
      </p>
      <p>
        Except as specifically set forth in this Section 3, we have no other
        obligations with respect to Notification Services.
      </p>
      <p>
        <b>4. Scope of Services.</b> You agree that Custodian is performing only
        ministerial services at your direction on behalf of the Plan pursuant to
        this Addendum. You represent for yourself and on behalf of the Plan that
        the ministerial services to be rendered by us under this Addendum are
        consistent with the procedures and terms of the Plan and all applicable
        Laws. Accordingly, you further agree for yourself and on behalf of the
        Plan that we are not intended to be a fiduciary, nor is it intended that
        we have the requisite authority or control, to perform any services or
        functions which could cause us to become a fiduciary of any Plan.
        Furthermore, you agree that we shall not be obligated to perform any
        services or to take any actions which, in our reasonable judgment, would
        cause us to be treated as a fiduciary under any applicable Laws, nor
        shall you request that we perform such actions. You on behalf of the
        Plan shall comply with all applicable Laws and regulations applicable to
        the Services in all respects. Each party is solely responsible for its
        own compliance obligations. Custodian expressly disclaims that the
        Notification Services are, and no services shall be deemed to be
        regulatory, compliance, legal, retirement fund/plan, ERISA or tax
        advice, counsel or opinion.
      </p>
      <p>
        <b>5. Representation and Warranties. </b> You hereby represent and
        warrant, for yourself and on behalf of the Plan, as follows:
      </p>
      <p>
        (i) This Addendum has been duly authorized, executed and delivered by
        you and constitutes a valid and binding agreement on behalf you and of
        each Plan.
      </p>
      <p>
        (ii) You have full power and authority from the Plan to enter into this
        Addendum and share the Plan’s Notification Information with us and any
        Services Vendor and to receive Notification Results.
      </p>
      <p>
        (iii) Notification Information provided is the most recent information
        available to you and the Plan.
      </p>
      <p>
        (iv) You and the Plan will comply with all Laws, regulations and rules
        which govern Notification Services.
      </p>
      <p>
        (v) You have relied on your own legal counsel and/or other tax/employee
        benefit professionals for advice in taking actions under the Plan,
        taking actions to notify participants and in executing this Addendum.
        You have independently concluded that the arrangement for Services
        described in this Addendum satisfies applicable Laws and you have not
        relied on us for any such advice, and we have not provided any
        recommendation or legal advice to you in connection with the
        Notification Services provided pursuant to this Addendum
      </p>
      <p>
        <b>6. Fees.</b> You agree to pay us fees for Notification Services
        pursuant to the Fee Schedule attached as Exhibit A hereto. Fees shall be
        invoiced or, at our option, pre-paid at the time Notification Services
        are ordered. Invoices are due no later than 30 days after the date of
        the invoice. We may amend the service fees from time to time by
        providing notice to you. You agree that your continued use of all or
        part of the Notification Services will be subject to your payment of any
        applicable fees.
      </p>
      <p>
        If any undisputed invoice remains unpaid 30 days after the invoice date,
        you will pay interest on the past due amounts at a rate which is the
        lesser of one and a half percent (1.5%) per month, or the highest rate
        permitted by applicable law, until payment in full is made. In the event
        we are required to take any action to collect overdue payments from you,
        including but not limited to engaging the services of a collection
        agency or initiating legal proceedings, you will be responsible for
        reimbursing us for all reasonable costs and expenses incurred in
        connection with such collection efforts, including attorney fees, court
        costs, and any other expenses.
      </p>
      <p>
        We reserve the right to suspend provision of Notification Services to
        you or on behalf of any Plan for which any invoice remains unpaid for a
        period exceeding sixty (60) days from the due date, until such time as
        the overdue amounts, including any applicable late payment penalties,
        interest, and collection costs, are paid in full.
      </p>
      <p>
        7. Indemnification and Limitation of Liability for Notification
        Services. You will indemnify, defend and hold us harmless from any and
        all Damages arising from or claimed to have arisen from (a) your or
        Plan’s material breach of this Addendum, including without limitation,
        any representation, warranty or certification made in this Addendum, (b)
        your or Plan’s breach of your or its confidentiality and information
        security obligations, (c) inaccurate Notification Information provided
        by you or your authorized agent; (d) any act or omission by us arising
        out of or resulting from our reliance upon the Notification Information,
        Notification Materials or any other directions or information provided
        by or on behalf of a Plan; and (e) your or Plan’s gross negligence,
        fraud, bad faith or willful misconduct.
      </p>
      <p>
        We will indemnify, defend and hold you harmless from any and all Damages
        arising from or claimed to have arisen from (a) our material breach of
        this Addendum, including any representation or warranty made by us,
        except Damages arising from your gross negligence, fraud, bad faith or
        willful misconduct; or (b) our gross negligence, fraud, bad faith or
        willful misconduct.
      </p>
      <p>
        Notwithstanding the foregoing, you agree that our aggregate liability
        for Damages, regardless of the cause of the Damages, shall not exceed
        the amount of fees paid by you under this Addendum in the twelve months
        preceding the event that gave rise to the Damages, even if you were
        advised of the possibility of such Damages. IN NO EVENT SHALL EITHER
        PARTY BE LIABLE TO THE OTHER FOR ANY INDIRECT, PUNITIVE, SPECIAL
        INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY NATURE WHATSOEVER.
      </p>
      <p>
        The terms of these limitations on liability will survive the termination
        of this Addendum.
      </p>
      <p>
        IN WITNESS WHEREOF, the parties hereto have caused this Addendum to be
        executed as of the date of the Plan Agent’s acceptance set forth below.
      </p>
    </div>
  )
}

export default NotificationsAddendumLanguageOfAgreement
